import { Component, Input, ViewChild } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { GoogleIntegrationDiagnosticPanelComponent } from '../google-integration-diagnostic-panel/google-integration-diagnostic-panel.component';

@Component({
  selector: 'app-google-integration-diagnostic',
  templateUrl: './google-integration-diagnostic.component.html'
})
export class GoogleIntegrationDiagnosticComponent {
  @Input() customerId!: number;
  @Input() isReadOnly = false;

  @ViewChild(GoogleIntegrationDiagnosticPanelComponent) diagnosticPanel?: GoogleIntegrationDiagnosticPanelComponent;

  constructor(public activeModal: NgbActiveModal) { }

  close(): void {
    this.activeModal.close({
      correctionTriggered: this.diagnosticPanel?.correctionTriggered ?? false,
      hasFreshDiagnostic: this.diagnosticPanel?.hasFreshDiagnostic ?? false
    });
  }
}
